import { useEffect, useMemo, useState } from 'react';
export const useDegradedSeconds = (connectionHealth, connectionReady, isRecording) => {
    const [degradedSinceMs, setDegradedSinceMs] = useState(null);
    const [tick, setTick] = useState(0);
    useEffect(() => {
        if (connectionHealth !== 'offline') {
            setDegradedSinceMs(null);
            return;
        }
        if (connectionReady || isRecording) {
            setDegradedSinceMs((prev) => prev ?? Date.now());
        }
    }, [connectionHealth, connectionReady, isRecording]);
    useEffect(() => {
        if (isRecording
            || (connectionHealth === 'offline' && connectionReady)) {
            const id = window.setInterval(() => {
                setTick((t) => t + 1);
            }, 1000);
            return () => {
                window.clearInterval(id);
            };
        }
    }, [isRecording, connectionHealth, connectionReady]);
    return useMemo(() => (degradedSinceMs === null
        ? 0
        : Math.floor((Date.now() - degradedSinceMs) / 1000)), [degradedSinceMs, tick]);
};
